<template>
  <div>
    <v-dialog v-model="dialog" max-width="450px">
      <v-alert prominent type="error">
        <v-row align="center">
          <v-col class="grow">
            {{ errorMessage }}
          </v-col>
          <v-col class="shrink">
            <v-btn icon @click="dialog = !dialog">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    dialog: true
  }),
  computed: {
    ...mapState('forward', ['errorMessage'])
  }
}
</script>

<style></style>
